import React, { Component } from 'react';

import classnames from 'classnames';

// Material UI Imports
import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import CardHeader from "@material-ui/core/CardHeader";
import CardText from "@material-ui/core/CardContent";
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
// Material Icons Imports
import IconActionAssignment from '@material-ui/icons/Assignment';
import IconActionQuestion from '@material-ui/icons/QuestionAnswer';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { withStyles } from '@material-ui/core/styles'

// Components Imports
import Question from './Question';
import NormalField from './NormalField';

// Lodash
import _ from 'lodash';

const styles = theme => ({
    expand: {
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
        marginLeft: 'auto',
        [theme.breakpoints.up('sm')]: {
            marginRight: -8,
        },
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    avatar: {
        backgroundColor: theme.palette.primary.main,
    }
});

class PRChecklist extends Component {
    state = {
        expandedPRC: this.props.initiallyExpanded ,
        expandedQuestions: this.props.initiallyExpanded 
    };

    handleExpandClickPRC = () => {
        this.setState(state => ({ expandedPRC: !state.expandedPRC }));
    };

    handleExpandClickQuestions = () => {
        this.setState(state => ({ expandedQuestions: !state.expandedQuestions }));
    };

    render() {
        const { classes } = this.props;

        let event = new Date(Date.parse(this.props.prc.date))

        const questionsSorted = _.orderBy(this.props.prc.questionGroup ? this.props.prc.questionGroup.questions : [], function (obj) {
            return parseInt(obj['position'], 10);
        });

        const questionsList = questionsSorted.map((question, id) =>
            <Question question={question} key={id} />
        );



        return (
            <div className="PRC">
                <Card elevation={0}>
                    <CardHeader
                        title="Post Remediation Checklist"
                        subheader={"On " + event.toDateString() + " at " + event.getHours() + ":" + event.getMinutes() + ":" + event.getSeconds()}
                        avatar={<Avatar className={classes.avatar}><IconActionAssignment /></Avatar>}
                        onClick={this.handleExpandClickPRC}
                        action={
                            <IconButton
                                className={classnames(classes.expand, {
                                    [classes.expandOpen]: this.state.expandedPRC,
                                })}
                                aria-expanded={this.state.expandedPRC}
                                aria-label="Show more"
                            >
                                <ExpandMoreIcon />
                            </IconButton>
                        }
                    />
                    <Collapse in={this.state.expandedPRC} timeout="auto" unmountOnExit>
                        <CardText >
                            <div>
                                <NormalField
                                    label="Supervisor"
                                    input={this.props.prc.device.user.fullName} />

                                <NormalField
                                    label="Enclosure"
                                    input={this.props.prc.enclosure.name} />
                            </div>
                            <Card>
                                <CardHeader
                                    title="Questions"
                                    avatar={<Avatar className={classes.avatar}><IconActionQuestion /></Avatar>}
                                    onClick={this.handleExpandClickQuestions}
                                    action={
                                        <IconButton
                                            className={classnames(classes.expand, {
                                                [classes.expandOpen]: this.state.expandedQuestions,
                                            })}
                                            aria-expanded={this.state.expandedQuestions}
                                            aria-label="Show more"
                                        >
                                            <ExpandMoreIcon />
                                        </IconButton>
                                    }
                                />
                                <Collapse in={this.state.expandedQuestions} timeout="auto" unmountOnExit>
                                    <CardText>
                                        {questionsList}
                                    </CardText>
                                </Collapse>
                            </Card>
                        </CardText>
                    </Collapse>
                </Card>
            </div >
        );
    }
}

export default withStyles(styles)(PRChecklist);


// WEBPACK FOOTER //
// src/components/innerComponents/PRChecklist.js